import { graphql } from '@/generated/gql';

export const NEGOTIATION_CASE_DETAIL_ISSUES_WIDGET_QUERY = graphql(/* GraphQL */ `
  query NegotiationCaseDetail($id: UUID!) {
    tesseract {
      negotiationCase(id: $id) {
        id
        issues {
          id
          variant
          status
        }
      }
    }
  }
`);
